<template>
<div class="filter-content">
  <span>
    <v-menu
      :close-on-content-click="false"
      offset-y
      :content-class="filterPending ? 'menu-opacity' : ''"
      max-height="700px"
      min-width="600px"
    >
      <template v-slot:activator="{ on : menu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on : tooltip }">
            <v-btn
              dark
              color="orange"
              v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>filter_list</v-icon>
            </v-btn>
          </template>
          <span>Фильтр</span>
        </v-tooltip>

      </template>
      <v-list class="filter-menu" @keyup.native.enter="goFilter">
        <v-list-item dense>
          <span class="filter-buttons filter-text">
            Фильтр
          </span>
          <v-spacer></v-spacer>
          <span class="filter-buttons filter-text">
            {{ count }} / {{ countTotal }}
          </span>
        </v-list-item>

        <!-- fields -->
        <v-row no-gutters>
          <v-col>
            <v-list-item>
              <v-text-field
                v-model="query.name__icontains"
                label="Название"
                hide-details
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
             <v-autocomplete
               :items="items.tags"
               v-model="query.tags"
               label="Теги"
               item-value="id"
               item-text="name"
               autocomplete
               multiple
               hide-details
               no-data-text="Нет результатов"
               clearable
             ></v-autocomplete>
            </v-list-item>

            <v-list-item>
             <v-select
               :items="items.statuses"
               v-model="query.status"
               label="Статус"
               item-value="value"
               item-text="name"
               hide-details
               no-data-text="Нет результатов"
               clearable
             ></v-select>
             </v-list-item>

             <v-list-item>
              <v-select
                :items="items.priorities"
                v-model="query.priority"
                label="Приоритет"
                item-value="value"
                item-text="name"
                hide-details
                no-data-text="Нет результатов"
                clearable
              ></v-select>
              </v-list-item>

              <v-list-item>
                <Date
                  v-model="query.date_created__gte"
                  label="Дата создания с"
                  :required="false"
                  :clearable="true"
                  :left="300"
                />
              </v-list-item>
              <v-list-item>
                <Date
                  v-model="query.date_created__lt"
                  label="Дата создания по"
                  :required="false"
                  :clearable="true"
                  :left="300"
                />
              </v-list-item>
          </v-col>

          <v-col>

            <v-list-item>
              <v-autocomplete
                   :items="items.organizations"
                   v-model="query.organization"
                   label="Организация"
                   item-value="id"
                   item-text="name"
                   autocomplete
                   hide-details
                   no-data-text="Нет результатов"
                   clearable
                ></v-autocomplete>
              </v-list-item>

          </v-col>
          <v-col>

            <v-list-item>
             <v-autocomplete
               :items="items.users"
               v-model="query.author"
               label="Автор"
               item-value="id"
               item-text="name"
               autocomplete
               hide-details
               no-data-text="Нет результатов"
               clearable
             ></v-autocomplete>
             </v-list-item>
             <v-list-item>
              <v-autocomplete
                :items="items.users"
                v-model="query.reponsible"
                label="Ответственный"
                item-value="id"
                item-text="name"
                autocomplete
                hide-details
                no-data-text="Нет результатов"
                clearable
              ></v-autocomplete>
              </v-list-item>
               <v-list-item>
                <v-autocomplete
                  :items="items.users"
                  v-model="query.watchers"
                  label="Наблюдатель"
                  item-value="id"
                  item-text="name"
                  autocomplete
                  hide-details
                  no-data-text="Нет результатов"
                  clearable
                ></v-autocomplete>
               </v-list-item>

          </v-col>
         </v-row>
         <v-row>
          <v-col>
            <v-list-item>
              <v-checkbox
                v-model="query.only_my"
                label="Только мои"
                hide-details
                :value="false"
                :disabled="!acl.see_all"
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                v-model="query.need_watch"
                label="Необходимо ознакомиться"
                hide-details
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                v-model="query.only_me_author_responsible"
                label="Я автор или постановщик"
                hide-details
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                v-model="query.only_me_assigned"
                label="Я исполнитель"
                hide-details
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                v-model="query.only_me_watcher"
                label="Я наблюдатель"
                hide-details
              ></v-checkbox>
             </v-list-item>

          </v-col>
          <v-col>
            <v-list-item>
              <v-checkbox
                v-model="query.show_closed"
                label="Показывать закрытые"
                hide-details
              ></v-checkbox>
             </v-list-item>

             <v-list-item>
               <v-checkbox
                 v-model="query.show_templates"
                 label="Показать шаблоны"
                 hide-details
               ></v-checkbox>
              </v-list-item>

             <v-list-item>
               <v-checkbox
                 v-model="query.date_end_for"
                 label="Должны быть выполнены до"
                 hide-details
               ></v-checkbox>
              </v-list-item>
              <v-list-item>
                <v-checkbox
                  v-model="query.overdue"
                  label="Просроченные"
                  hide-details
                ></v-checkbox>
               </v-list-item>
          </v-col>

          <v-col>
          </v-col>
        </v-row>
        <!-- fields -->

        <v-list-item>
          <v-spacer></v-spacer>
          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  color="orange"
                  v-on="on"
                  @click="resetFilter"
                >
                <i class="fas fa-ban fa-lg"></i>
                </v-btn>
              </template>
              <span>Сбросить</span>
            </v-tooltip>
          </span>

          <span class="filter-buttons">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="filterPending"
                  dark
                  color="orange"
                  v-on="on"
                  @click="goFilter"
                >
                <i class="fas fa-search fa-lg"></i>
                </v-btn>
              </template>
              <span>Поиск</span>
            </v-tooltip>
          </span>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</div>
</template>

<script>
import { removeNulls } from '@/utils'
import FilterMixin from '@/components/filters/Filter.vue'

export default {
  mixins: [FilterMixin],
  props: {
  },
  watch: {
    'acl.see_all' () {
      if (!this.acl.see_all) {
        this.query.only_my = true
      }
    }
  },
  data: function () {
    return {
      disabled: ['only_my'],
      items: {
        statuses: [
          { name: 'Новая', value: 'open' },
          { name: 'В работе', value: 'processed' },
          { name: 'Выполнена', value: 'completed' },
          { name: 'Готово к выдаче', value: 'issue' },
          { name: 'Закрыта', value: 'closed' },
          { name: 'Переоткрыта', value: 'reopened' },
          { name: 'Отменена', value: 'canceled' },
        ],
        priorities: [
          { name: 'Блокирующий', value: 'blocking' },
          { name: 'Высокий', value: 'high' },
          { name: 'Нормальный', value: 'medium' },
          { name: 'Желательный', value: 'low' },
        ],
        tags: [],
        posts: [],
        organizations: [],
        clients: []
      },
      refs: [
        { url: 'users/?fields[]=name&sort_by=last_name', name: 'users' },
        { url: 'task/tags/', name: 'tags' },
        { url: 'organizations/?status=active', name: 'organizations' },
        { url: 'clients/', name: 'clients' },
        { url: 'subdivisions/?is_active=true&fields[]=short_name&fields[]=name', name: 'subdivision' },

      ],
    }
  },
}
</script>
<style scoped>
</style>
